import API from "../api/axios";

// Khoá VAPID dạng base64url -> Uint8Array cho pushManager.subscribe
function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const isPushSupported = () =>
    "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const getPushPermission = () => (isPushSupported() ? Notification.permission : "unsupported");

export async function getCurrentSubscription() {
    if (!isPushSupported()) return null;
    const registration = await navigator.serviceWorker.getRegistration();
    return registration ? registration.pushManager.getSubscription() : null;
}

/**
 * Xin quyền và đăng ký nhận thông báo cho thiết bị hiện tại.
 * Phải gọi từ thao tác bấm của người dùng (iOS bắt buộc).
 */
export async function subscribePush() {
    if (!isPushSupported()) {
        throw new Error("Trình duyệt này chưa hỗ trợ thông báo. Trên iPhone cần iOS 16.4+ và đã cài app ra màn hình chính.");
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        throw new Error("Bạn đã chặn quyền thông báo. Hãy bật lại trong cài đặt trình duyệt.");
    }

    // serviceWorker.ready chờ mãi nếu chưa có service worker (vd chạy npm start) -> giới hạn 10 giây
    const registration = await Promise.race([
        navigator.serviceWorker.ready,
        new Promise((_, reject) => setTimeout(() => reject(new Error("Ứng dụng chưa sẵn sàng nhận thông báo, vui lòng tải lại trang và thử lại.")), 10000)),
    ]);
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
        const res = await API.get("/push/public-key");
        const publicKey = res.data?.data?.public_key;
        if (!publicKey) throw new Error("Server chưa cấu hình thông báo.");

        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey),
        });
    }

    // Ưu tiên chuẩn mới aes128gcm (Apple, Chrome, Firefox đều hỗ trợ), chỉ dùng aesgcm khi không có lựa chọn khác
    const encodings = window.PushManager.supportedContentEncodings || ["aes128gcm"];
    const contentEncoding = encodings.includes("aes128gcm") ? "aes128gcm" : encodings[0];

    const json = subscription.toJSON();
    await API.post("/push/subscribe", {
        endpoint: json.endpoint,
        keys: json.keys,
        content_encoding: contentEncoding,
    });

    return subscription;
}

export async function unsubscribePush() {
    const subscription = await getCurrentSubscription();
    if (!subscription) return;
    await API.post("/push/unsubscribe", { endpoint: subscription.endpoint }).catch(() => {});
    await subscription.unsubscribe();
}
